var _g, _tspan, _tspan2, _tspan3, _tspan4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedbackLoopSeeImpact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 630 711",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-4641.84,-1633.13)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.988152,0,0,0.977324,5192.64,2235.44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-478.231C-29.127,-526.216 -14.019,-558.794 -69.718,-565.764C-127.79,-573.032 -185.257,-552.96 -242.451,-540.552C-299.645,-528.143 -364.705,-524.938 -411.291,-560.363C-419.952,-566.949 -427.828,-574.786 -437.613,-579.544C-465.443,-593.078 -499.48,-577.332 -520.561,-554.677C-566.312,-505.511 -569.948,-422.668 -528.681,-369.682C-507.151,-342.04 -476.442,-323.403 -448.986,-301.635C-421.53,-279.868 -395.601,-252.018 -390.563,-217.344C-386.055,-186.307 -399.203,-155.319 -416.066,-128.876C-432.929,-102.432 -453.822,-78.458 -467.725,-50.345C-481.628,-22.232 -487.739,12.2 -473.549,40.168C-456.028,74.705 -414.358,88.545 -376.313,95.776C-275.971,114.847 -167.953,109.643 -77.568,62.074C12.817,14.504 81.604,-80.534 80.129,-182.663C78.648,-285.196 10.734,-376.25 0,-478.231",
    style: {
      fill: "rgb(240,239,255)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.807149,0,0,0.807149,3810.17,1561.42)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1595.42,180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,732L-300.021,732C-330.266,732 -354.784,707.481 -354.784,677.237L-354.784,54.763C-354.784,24.519 -330.266,0 -300.021,0L0,0C30.245,0 54.763,24.519 54.763,54.763L54.763,677.237C54.763,707.481 30.245,732 0,732",
    style: {
      fill: "rgb(40,54,85)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1588.4,176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,706L-285.474,706C-315.719,706 -340.237,681.481 -340.237,651.237L-340.237,54.763C-340.237,24.519 -315.719,0 -285.474,0L0,0C30.245,0 54.763,24.519 54.763,54.763L54.763,651.237C54.763,681.481 30.245,706 0,706Z",
    style: {
      fill: "rgb(245,246,247)",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: "17.35px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,1444.23,316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-163.474,-163.474C-253.758,-163.474 -326.948,-90.285 -326.948,0C-326.948,90.284 -253.758,163.474 -163.474,163.474C-73.19,163.474 0,90.284 0,0C0,-90.285 -73.19,-163.474 -163.474,-163.474",
    style: {
      fill: "rgb(255,206,199)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1506.32,177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,22L-121.324,22C-132.319,22 -142.436,15.991 -147.695,6.336L-151.146,0L29.822,0L26.371,6.336C21.111,15.991 10.995,22 0,22",
    style: {
      fill: "rgb(40,54,85)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1438.32,642.92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-108.4L11.83,-108.4C63.869,-108.4 108.247,-70.701 116.661,-19.345L119.83,0L-108,0L-104.831,-19.345C-96.417,-70.701 -52.04,-108.4 0,-108.4Z",
    style: {
      fill: "rgb(245,246,247)",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: "3.24px",
      strokeLinecap: "butt"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1473.63,601.781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-72.158L0,-29.397C0,-13.16 -13.16,0 -29.398,0C-45.635,0 -58.795,-13.16 -58.795,-29.397L-58.795,-72.158L0,-72.158Z",
    style: {
      fill: "white",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: "3.24px",
      strokeLinecap: "butt"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,1,0,1364.89,445.71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.061,-13.06C20.274,-13.06 26.121,-7.212 26.121,0.001C26.121,7.213 20.274,13.061 13.061,13.061C5.848,13.061 0,7.213 0,0.001C0,-7.212 5.848,-13.06 13.061,-13.06",
    style: {
      fill: "rgb(245,246,247)",
      fillRule: "nonzero"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(78.3741,6.04917e-16,-6.04917e-16,-73.4346,1405.04,612.541)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0158079,1.30217e-19,-1.30217e-19,-0.0168712,-4.78043,7.1315)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image1",
    x: 235,
    y: 393,
    width: "198px",
    height: "59.962px",
    transform: "matrix(1,0,0,0.99936,0,0)"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,1444.23,517.542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-33.631,-33.63C-52.204,-33.63 -67.261,-18.573 -67.261,0C-67.261,18.574 -52.204,33.631 -33.631,33.631C-15.057,33.631 0.001,18.574 0.001,0C0.001,-18.573 -15.057,-33.63 -33.631,-33.63",
    style: {
      fill: "rgb(40,54,85)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,1,0,1364.89,445.71)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.061,
    cy: 0.001,
    r: 13.061,
    style: {
      fill: "none",
      stroke: "rgb(40,54,85)",
      strokeWidth: "3.24px",
      strokeLinecap: "butt"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,1,0,1521.61,445.711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.061,-13.06C20.274,-13.06 26.121,-7.213 26.121,0.001C26.121,7.214 20.274,13.061 13.061,13.061C5.848,13.061 -0,7.214 -0,0.001C-0,-7.213 5.848,-13.06 13.061,-13.06",
    style: {
      fill: "rgb(245,246,247)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1443.91,356.085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,219.739C-8.073,219.739 -15.877,218.592 -23.26,216.453C-58.015,206.383 -83.423,174.316 -83.423,136.316L-83.423,83.422C-83.423,37.349 -46.073,0 0,0C46.073,0 83.422,37.349 83.422,83.422L83.422,136.316C83.422,182.389 46.073,219.739 0,219.739",
    style: {
      fill: "rgb(40,54,85)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,1,0,1521.61,445.711)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.06,
    cy: 0.001,
    rx: 13.06,
    ry: 13.06,
    style: {
      fill: "none",
      stroke: "rgb(40,54,85)",
      strokeWidth: "3.24px",
      strokeLinecap: "butt"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1499.25,495.014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-88.353L0,-19.206C0,-8.598 -8.597,0 -19.205,0L-22.708,0L-26.999,-7.481C-28.981,-10.932 -32.657,-13.061 -36.637,-13.061L-73.722,-13.061C-77.702,-13.061 -81.378,-10.932 -83.36,-7.481L-87.651,0L-91.154,0C-101.762,0 -110.359,-8.598 -110.359,-19.206L-110.359,-63.669L-110.232,-63.827C-105.057,-71.959 -95.96,-76.998 -86.557,-79.124C-77.153,-81.249 -67.368,-80.772 -57.766,-79.923C-48.16,-79.078 -38.524,-77.873 -28.909,-78.582C-19.293,-79.29 0,-88.353 0,-88.353Z",
    style: {
      fill: "rgb(245,246,247)",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: "3.24px",
      strokeLinecap: "butt"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,1422.03,444.405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-7.183,-7.184C-11.15,-7.184 -14.367,-3.968 -14.367,-0.001C-14.367,3.967 -11.15,7.183 -7.183,7.183C-3.216,7.183 0,3.967 0,-0.001C0,-3.968 -3.216,-7.184 -7.183,-7.184",
    style: {
      fill: "rgb(40,54,85)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,1466.11,444.405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-7.183,-7.184C-11.15,-7.184 -14.367,-3.968 -14.367,-0.001C-14.367,3.967 -11.15,7.183 -7.183,7.183C-3.216,7.183 0,3.967 0,-0.001C0,-3.968 -3.216,-7.184 -7.183,-7.184",
    style: {
      fill: "rgb(40,54,85)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.921423,-0.388561,-0.388561,-0.921423,1508.8,387.67)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.749,3.703C-0.749,3.703 9.33,6.78 18.309,3.703",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: "3.24px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.349992,-0.936753,-0.936753,-0.349992,1510.91,380.522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.778,5.444C-3.778,5.444 -0.45,3.391 7.846,5.444",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: "3.24px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1359.43,329.801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,84.774C0,37.955 37.955,0 84.774,0C131.593,0 169.548,37.955 169.548,84.774",
    style: {
      fill: "rgb(108,99,255)",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: "4.05px",
      strokeLinecap: "butt"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1522.36,389.948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,48.454C-50.042,27.819 -106.267,27.819 -156.309,48.454C-164.678,51.893 -171.249,48.339 -171.251,39.7C-171.249,31.08 -164.679,20.634 -156.309,17.196C-106.267,-3.439 -50.042,-3.439 0,17.196C8.37,20.635 14.941,31.079 14.942,39.7C14.94,48.341 8.37,51.893 0,48.454Z",
    style: {
      fill: "rgb(108,99,255)",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: "3.03px",
      strokeLinecap: "butt"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,1,0,1375.35,423.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10.774,-10.774L10.774,-10.774",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: "3.24px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,1,0,1384.44,419.733)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10.774,-10.774L10.774,-10.774",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: "3.24px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,1,0,1393.81,416.659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10.774,-10.774L10.774,-10.774",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: "3.24px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,1,0,1403.44,414.088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10.774,-10.774L10.774,-10.774",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: "3.24px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,1,0,1413.32,411.987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10.774,-10.774L10.774,-10.774",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: "3.24px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,1,0,1423.42,410.325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10.774,-10.774L10.774,-10.774",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: "3.24px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,1,0,1433.73,409.07)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10.774,-10.774L10.774,-10.774",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: "3.24px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,1,0,1444.23,408.189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10.774,-10.774L10.774,-10.774",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: "3.24px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,1,0,1454.91,407.652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10.774,-10.774L10.774,-10.774",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: "3.24px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,1,0,1465.34,408.185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10.774,-10.774L10.774,-10.774",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: "3.24px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,1,0,1475.63,409.139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10.774,-10.774L10.774,-10.774",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: "3.24px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,1,0,1485.79,410.502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10.774,-10.774L10.774,-10.774",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: "3.24px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,1,0,1495.82,412.272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10.774,-10.774L10.774,-10.774",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: "3.24px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,1,0,1505.72,414.444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10.774,-10.774L10.774,-10.774",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: "3.24px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,1,0,1515.48,417.016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10.774,-10.774L10.774,-10.774",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: "3.24px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,1,0,1525.11,419.982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10.774,-10.774L10.774,-10.774",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: "3.24px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,1,0,1534.6,423.34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10.774,-10.774L10.774,-10.774",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(40,54,85)",
      strokeWidth: "3.24px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.0478506,0.998855,0.998855,0.0478506,1495.08,352.168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.344,-57.582C42.045,-26.815 45.15,6.512 55.445,35.514C55.347,35.235 40.394,38.716 41.344,30.798C41.781,27.157 43.848,15.599 43.723,11.809C43.598,8.022 39.898,-35.116 41.344,-57.582",
    style: {
      fill: "rgb(40,54,85)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1654.15,251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,78L-4.988,78L-4.988,0L0,0C2.216,0 4.012,1.796 4.012,4.012L4.012,73.988C4.012,76.204 2.216,78 0,78",
    style: {
      fill: "rgb(40,54,85)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1654.15,347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,78L-4.988,78L-4.988,0L0,0C2.216,0 4.012,1.796 4.012,4.012L4.012,73.988C4.012,76.204 2.216,78 0,78",
    style: {
      fill: "rgb(40,54,85)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1531.91,777.163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,32L-199.5,32C-208.336,32 -215.5,24.837 -215.5,16C-215.5,7.163 -208.336,0 -199.5,0L0,0C8.836,0 16,7.163 16,16C16,24.837 8.836,32 0,32",
    style: {
      fill: "rgb(212,215,221)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1382.91,234.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,32L-25,32C-33.836,32 -41,24.837 -41,16C-41,7.163 -33.836,0 -25,0L0,0C8.836,0 16,7.163 16,16C16,24.837 8.836,32 0,32",
    style: {
      fill: "rgb(212,215,221)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1302.91,234.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,32L13,32C21.836,32 29,24.837 29,16C29,7.163 21.836,0 13,0L0,0C-8.836,0 -16,7.163 -16,16C-16,24.837 -8.836,32 0,32",
    style: {
      fill: "rgb(255,235,233)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1589.91,234.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,32L-30,32C-38.836,32 -46,24.837 -46,16C-46,7.163 -38.836,0 -30,0L0,0C8.836,0 16,7.163 16,16C16,24.837 8.836,32 0,32",
    style: {
      fill: "rgb(212,215,221)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1464.91,822.163)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,32L-132.5,32C-141.336,32 -148.5,24.837 -148.5,16C-148.5,7.163 -141.336,0 -132.5,0L0,0C8.836,0 16,7.163 16,16C16,24.837 8.836,32 0,32",
    style: {
      fill: "rgb(212,215,221)",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,5394.99,1723.34)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "-521px",
    y: "400.921px",
    style: {
      fontFamily: "'Lato-Bold', 'Lato', sans-serif",
      fontWeight: 700,
      fontSize: "33.333px",
      fill: "rgb(147,155,170)"
    }
  }, "T", _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: "-501.3px ",
    y: "400.921px "
  }, "h")), "ank ", _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: "-421.7px -404.65px ",
    y: "400.921px 400.921px "
  }, "yo")), "u f", _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: "-347.1px ",
    y: "400.921px "
  }, "o")), "r"), /*#__PURE__*/React.createElement("text", {
    x: "-521px",
    y: "437.587px",
    style: {
      fontFamily: "'Lato-Bold', 'Lato', sans-serif",
      fontWeight: 700,
      fontSize: "33.333px",
      fill: "rgb(147,155,170)"
    }
  }, "helping B", _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: "-382.5px ",
    y: "437.587px "
  }, "o")), "b"))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "_Image1",
    width: "198px",
    height: "60px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMYAAAA8CAYAAAA9ksUiAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABJklEQVR4nO3csU0DQRRF0efdkaAfGqcJCiClCwIwkhEQrGwjzct3g3Mq+MnV94zHPn18np+SXAJcvY8kP0ne9p4EDuR7JFmTPOw9CRzIrzBgdhEGzL6EAbPlGsbj3pPAgYyRZMTGgP9WH6VgNoQBMxsDilsYy96TwIHcwhh7TwIH4owBhTMGFMKAQhhQDE9CYLZ6EgIzH6WgcF0LhY0BhTCgWN1KwcwZA4pFGDCzMaBw+IbCxoBiuT4JcSsFd2Nk+1mrjQF3HhFCYWNA4XsMKNxKQbG6lYLZGElO2bYGsDn5B0IohAGFMKAQBhTCgEIYUAgDCmFAIQwohAGFMKAQBhTCgEIYUAgDCmFAIQwohAGFMKAQBhTCgEIYUIwkz0le9x4EDuTlDyc5D42SvcovAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackLoopSeeImpact);
export default __webpack_public_path__ + "static/media/feedback_loop_see_impact.2227525c.svg";
export { ForwardRef as ReactComponent };